import { IGenericAnalysis } from "../../../omnia";
import { IAnalysisLayerData } from "../map/analysis-layer";
import { IGlobalAllocationBindingModel } from "../types";
import { GlobalAnalysisAlloc } from "./alloc-vm";

export abstract class GlobalAnalysisVM {

    public allocations: GlobalAnalysisAlloc[];

    constructor(public analysis: IGenericAnalysis) {
        this.allocations = [];
    }

    get shownAllocations(): GlobalAnalysisAlloc[] {
        return this.allocations.filter(a => a.shown);
    }

    abstract getAnalysisId(): number;
    abstract getDescription(): string;
    abstract alloc(data: IAnalysisLayerData);
    abstract checkAllocationInDatas(allocation: GlobalAnalysisAlloc, datas: IAnalysisLayerData[]): boolean;
    abstract checkDataInAllocations(data: IAnalysisLayerData): boolean;
    abstract unallocFeature(data: IAnalysisLayerData);
    abstract getAllocationModels(): IGlobalAllocationBindingModel[];

    public allocationsChanged(): boolean {

        var originalAllocations = this.analysis.Allocations;
        var updatedAllocations = this.allocations;

        if (originalAllocations.length !== updatedAllocations.length) {
            return true;
        }

        return updatedAllocations.filter(a => !a.allocation).length > 0;

    }
}
